import { IApplicationState, TCardId } from '../../../../../../../../types/types';

export const getCardNameRename = (
    state: IApplicationState
): TCardId => {
    return state.cardPanel.cardName.renameCardId;
};
